import {
  RECORD_USERINFO,
  AUTO_USERINFO,
  LEVELINFO,
  UNREADCOUNT,
  OUT_LOGIN,
  // BALANCE,
  PROTECT,
  BANKLIST,
  MY_BANKCARD,
  USER_WITHDRAW,
  BILL_GROUP,
  LOTTERYMENU,
  LOTTERYLIST,
  GROUPLOTTERYLIST,
  LOTTERYLOAD,
  BETARRAY,
  CONFIG_INFO,
  SERVICE,
  ALLLOTTERYID,
  AWCOUNT,
  CREDITINFO
} from './mutation-types.js'
import { addCookie, deleteCookie } from '@/common/js/cookies'
// import { saveToLocal } from '@/common/js/store'

export default {
  // 登陆注册试玩记录用户信息
  [RECORD_USERINFO](state, info) {
    state.userInfo = info
    state.logined = true
    state.unread = info.unReadCount
    // saveToLocal('token', info.token ? info.token : '')
    addCookie('isLogined', true, 120)
  },
  // 自动登陆
  [AUTO_USERINFO](state, info) {
    state.userInfo = info
    state.unread = info.unReadCount
    state.logined = true
  },
  // 退出登录
  [OUT_LOGIN](state) {
    state.userInfo = null
    state.logined = false
    deleteCookie('isLogined')
  },
  // 积分等级等信息
  [LEVELINFO](state, info) {
    if (info) {
      state.levelInfo = info
      state.balance.data = {
        'bonus': info.bonus,
        'commission': info.commission,
        'handsel': info.handsel,
        'recharge': info.recharge
      }
      let balance = 0
      for (let i in state.balance.data) {
        balance += parseFloat(state.balance.data[i])
        balance = Math.round(balance * 1000) / 1000
      }
      state.balance.all = balance.toFixed(3)
    } else {
      state.levelInfo = info
      state.balance = {}
    }
  },
  // 更新未读条数
  [UNREADCOUNT](state, count) {
    state.levelInfo.unread = count
  },
  // 余额
  // [BALANCE](state, info) {
  //   let balance = 0
  //   for (let i in info) {
  //     balance += parseFloat(info[i])
  //     balance = Math.round(balance * 1000) / 1000
  //   }
  //   state.balance.all = balance.toFixed(3)
  //   state.balance.data = info
  // },
  // 保存安全资料信息
  [PROTECT](state, info) {
    state.protectData = info
  },
  // 全部银行列表
  [BANKLIST](state, info) {
    state.bankList = info
  },
  // 绑定的银行列表(包括还没审批通过的)
  [MY_BANKCARD](state, info) {
    state.my_bankCard = info
  },
  // 保存余额，充值资金和可提现资金
  [USER_WITHDRAW](state, info) {
    state.user_withdraw = info
  },
  // 保存记录分组数据
  [BILL_GROUP](state, info) {
    let arr = [{value: '', label: '全部'}]
    for (let i = 0; i < info.length; i++) {
      let obj = {}
      obj.value = info[i].id
      obj.label = info[i].group_name
      arr.push(obj)
    }
    state.bill_group = arr
  },
  // 彩种分类接口返回数据（type为5）
  [LOTTERYMENU](state, info) {
    state.lotteryMenu = info
  },
  // 购彩大厅显示的彩种
  [LOTTERYLIST](state, info) {
    state.lotteryList = info
  },
  // 购彩大厅某种类显示的彩种
  [GROUPLOTTERYLIST](state, info) {
    state.groupLotteryList = info
  },
  // 购彩大厅点击某种彩种时显示加载
  [LOTTERYLOAD](state, info) {
    state.lottery_load = info
  },
  // 投注订单数组
  [BETARRAY](state, info) {
    state.betArr.push(info)
  },
  // 网站基本信息
  [CONFIG_INFO](state, info) {
    state.config_info = info
  },
  // 客服网址
  [SERVICE](state, info) {
    state.service = info
  },
  // 所有彩种的id
  [ALLLOTTERYID](state, info) {
    state.allLotteryId = info
  },
  // 更新活动中心领取条数
  [AWCOUNT](state, count) {
    state.levelInfo.unReadSalaryCount = count
  },
  [CREDITINFO](state, info) {
    state.creditInfo = info
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js